module.exports = require("@magento/peregrine/lib/context/cart");